;(function () {
  var doc = document.documentElement
  var w = window

  var prevScroll = w.scrollY || doc.scrollTop
  var curScroll
  var direction = 0
  var prevDirection = 0

  var header = document.getElementById('planted-sticky-header')
  // the badge "Free shipping from CHF 27" goes out the header at the bottom,
  // hence add a bit more height to also hide the badge while scrolling down
  const badgeExtraHeight = 32 // 2 lines of text
  function getHeaderHeight() {
    return (
      parseInt(
        window.getComputedStyle(header.querySelector('header')).height,
        10
      ) + badgeExtraHeight
    )
  }

  let height = getHeaderHeight()
  let currY = 0

  window.addEventListener('resize', function () {
    height = getHeaderHeight()
  })

  function getOffsetYBody() {
    return (
      document.getElementById('shopify-section-header').getBoundingClientRect()
        .y + document.documentElement.scrollTop
    )
  }
  var checkScroll = function () {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */

    curScroll = w.scrollY || doc.scrollTop
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1
    }

    if (
      direction === 2 &&
      header.style.position !== 'fixed' &&
      curScroll > height
    ) {
      // scrolling down from the very top
      header.style.transitionDuration = '0s'
      header.style.position = 'fixed'
      header.style.top = `${getOffsetYBody()}px`
      header.classList.add('js-fixed')
      currY = height
      header.style.transform = `translateY(-${currY}px)`
    } else if (curScroll <= 0) {
      // scrolling up to the very top
      header.style.transitionDuration = '0s'
      header.style.position = 'relative'
      header.classList.remove('js-fixed')
      header.style.top = '0px'
      currY = 0
      header.style.transform = ''
    } else {
      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll)
      }
    }

    if (header.classList.contains('js-fixed')) {
      // only for window resize. required for Cozy country redirect banner above the header
      header.style.top = `${getOffsetYBody()}px`
    }

    prevScroll = curScroll
  }

  const miniCartEl = document.querySelector('[data-mini-cart]')

  var toggleHeader = function (direction, curScroll) {
    unsetClassesFromAttribute('data-show-class', miniCartEl)

    if (direction === 2) {
      if (curScroll > height) {
        // hide
        header.style.transitionDuration = '0.3s'
        currY = height
        header.style.transform = `translateY(-${currY}px)`
      }
      prevDirection = direction
    } else if (direction === 1) {
      // show
      header.style.transitionDuration = '0.3s'
      currY = 0
      header.style.transform = ''

      prevDirection = direction
    }
  }

  window.addEventListener('scroll', checkScroll)

  // cart

  function setClassesFromAttribute(attr, el) {
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.add(...classes)
  }

  function unsetClassesFromAttribute(attr, el) {
    if (!el) {
      return
    }
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.remove(...classes)
  }

  function updateCartIconCount() {
    const totalEl = document.querySelector('.js-cart-item-count')
    totalEl.innerText = cart.item_count
  }

  let cartChanges, cart
  document.addEventListener('theme:added_to_cart', function (event) {
    cartChanges = event.detail.changes
    cart = event.detail.cart
    updateCartIconCount()

    if (window.matchMedia('(max-width: 576px)').matches) {
      // show mini cart
      header.style.transform = ''
      miniCartEl.querySelector('[data-added-items]').innerHTML =
        cartChanges.quantity

      setClassesFromAttribute('data-show-class', miniCartEl)
    } else {
      // show normal cart popup
      const customEvent = new CustomEvent('theme:show_cart', {
        detail: {
          cart,
          changes: cartChanges
        }
      })
      document.dispatchEvent(customEvent)
    }
  })

  document.addEventListener('theme:cart_updated', function (event) {
    cart = event.detail.cart
    cartChanges = undefined
    updateCartIconCount()
  })

  document.querySelectorAll('[data-cart-button]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault()

      if (window.location.pathname === '/cart') {
        // on cart page, do not open the cart popup, for 2 reasons:
        // 1. we are already showing the cart
        // 2. the cart page is rendered server side, and every modification will reload the page.
        //    This means the cart popup would not stay in sync with the main cart
        return
      }

      let payload
      if (cart) {
        payload = {
          detail: {
            cart
          }
        }
      }
      const customEvent = new CustomEvent('theme:show_cart', payload)
      document.dispatchEvent(customEvent)
      unsetClassesFromAttribute('data-show-class', miniCartEl)
    })
  })

  miniCartEl
    .querySelector('[data-mini-cart-open]')
    .addEventListener('click', function () {
      const customEvent = new CustomEvent('theme:show_cart', {
        detail: {
          cart,
          changes: cartChanges
        }
      })
      document.dispatchEvent(customEvent)
      unsetClassesFromAttribute('data-show-class', miniCartEl)
    })

  miniCartEl
    .querySelector('[data-mini-cart-close]')
    .addEventListener('click', function () {
      unsetClassesFromAttribute('data-show-class', miniCartEl)
    })
})()
